/**
 * 
 * key
 * 
 */


const key = 'ZmxyUGVuZGluZ0RhdGFSZXBvcnQK'

export default key 